import React, { type InputHTMLAttributes, type Ref } from "react";

type InputSurface = "canvas" | "panel";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  surface?: InputSurface;
  mono?: boolean;
  ref?: Ref<HTMLInputElement>;
}

const SURFACE_CLASSES: Record<InputSurface, string> = {
  canvas: "bg-canvas",
  panel: "bg-canvas",
};

const BASE_CLASSES =
  "border-2 border-ink px-3 py-2.5 text-ink placeholder:text-muted focus:outline-none focus:border-accent focus:ring-0";

export function Input({
  surface = "canvas",
  mono = false,
  className,
  ...rest
}: InputProps) {
  return (
    <input
      className={[
        BASE_CLASSES,
        SURFACE_CLASSES[surface],
        mono ? "font-mono text-xs" : "font-mono text-sm",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...rest}
    />
  );
}
